import { stationOpsApi } from "../config/apiConfig";
import { CursorPage, DispatchRecord } from "../types/alerting";

interface ListOptions {
  limit?: number;
  cursor?: string | null;
}

const toRecord = (raw: any): DispatchRecord => ({
  dispatchId: raw.dispatch_id,
  locationId: raw.location_id,
  notificationType: raw.notification_type,
  recipient: raw.recipient,
  channel: raw.channel,
  dispatchedAt: raw.dispatched_at,
  recordedAt: raw.recorded_at,
  suppressed: raw.suppressed === true,
  suppressionReason: raw.suppression_reason ?? null,
});

/** Reads one batch of the dispatch audit for a site, newest first. */
export const listDispatches = async (
  locationId: string,
  { limit, cursor }: ListOptions = {},
): Promise<CursorPage<DispatchRecord>> => {
  const params: Record<string, unknown> = {};
  if (limit !== undefined) params.limit = limit;
  if (cursor) params.cursor = cursor;

  const response = await stationOpsApi.get(
    `/internal/notification-dispatches/${encodeURIComponent(locationId)}`,
    { params },
  );

  return {
    content: (response.data?.content ?? []).map(toRecord),
    nextCursor: response.data?.next_cursor ?? null,
  };
};
